import React from "react";
import { StyleSheet, Platform, Share } from "react-native";
import { Feather } from "@expo/vector-icons";
import { attributes } from "../../theme";

const share = (props) => {
  const { gameId } = props;
  return Platform.select({
    default: () => (
      <Feather
        name="share"
        size={28}
        style={styles.shareButton}
        onPress={() =>
          Share.share({
            title: `Share your game ${gameId}`,
            message: `Join your friends Tipple game with ID: ${gameId}`,
          })
        }
      />
    ),
    web: () => null,
  })();
};

const styles = StyleSheet.create({
  shareButton: {
    color: attributes.mainColor,
  },
});

export default share;
